module.exports = __webpack_public_path__ + "img/animation.ed5edb69.png";